<template>
  <div class="is-pc pc-guide">
    <header class="pc-header">
      <div class="header-left">
        <h1>三高体检 · 内勤管理</h1>
        <span class="page-title">使用引导</span>
      </div>
    </header>

    <main class="pc-body">
      <div class="guide-card">
        <div class="guide-title">
          <div class="guide-icon">微</div>
          <div>
            <strong>元脉健康</strong>
            <small>三高体检 · 内勤服务平台</small>
          </div>
        </div>

        <div class="guide-step">
          <span class="step-no">方式一</span>
          <div class="step-body">
            <strong>微信搜索关注</strong>
            <p>打开微信「搜一搜」，搜索公众号 <b>元脉健康</b>，点击关注。</p>
          </div>
        </div>

        <div class="guide-step">
          <span class="step-no">方式二</span>
          <div class="step-body">
            <strong>扫码关注</strong>
            <p>使用微信「扫一扫」，扫描下方二维码即可关注。</p>
          </div>
        </div>

        <div class="qr-wrap">
          <img :src="qrImage" alt="元脉健康公众号二维码" class="qr-image" />
          <p class="qr-tip">扫码关注「元脉健康」</p>
        </div>

        <div class="guide-entry">
          <strong>手机使用内勤端</strong>
          <p>关注公众号后，从公众号底部菜单「内勤端」进入内勤工作台，手机上即可登录使用。</p>
        </div>

        <button class="entry-btn" @click="goLogin">进入内勤端（电脑端）</button>
      </div>
    </main>
  </div>
</template>

<script>
import qrImage from "@/assets/sanGao/yuanmaiGongZhongHao.jpg";

export default {
  name: "SanGaoStaffPcGuide",
  data() {
    return {
      qrImage,
    };
  },
  methods: {
    goLogin() {
      this.$router.push("/sanGao/staff/pc/login");
    },
  },
};
</script>

<style lang="less" scoped>
.is-pc.pc-guide {
  min-height: 100vh;
  background: #eef5fa;
}

.is-pc .pc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 28px;
  background: linear-gradient(100deg, #0a6bb8, #168de0);
  color: #fff;
}

.is-pc .header-left {
  display: flex;
  align-items: baseline;
  gap: 14px;
}

.is-pc .pc-header h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.is-pc .page-title {
  font-size: 14px;
  opacity: 0.9;
}

.is-pc .pc-body {
  display: flex;
  justify-content: center;
  padding: 40px 24px;
}

.is-pc .guide-card {
  width: 460px;
  padding: 30px 34px 28px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(12, 91, 147, 0.1);
}

.is-pc .guide-title {
  display: flex;
  align-items: center;
  padding-bottom: 18px;
  border-bottom: 1px solid #eef4f9;
}

.is-pc .guide-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-right: 14px;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #27b1e9, #1979d6);
}

.is-pc .guide-title strong {
  display: block;
  font-size: 18px;
  color: #163b5c;
}

.is-pc .guide-title small {
  display: block;
  margin-top: 3px;
  font-size: 12px;
  color: #7c8d9c;
}

.is-pc .guide-step {
  display: flex;
  margin-top: 16px;
  padding: 13px 14px;
  border-radius: 10px;
  background: #f4fafd;
}

.is-pc .step-no {
  flex: 0 0 auto;
  margin-right: 12px;
  padding: 3px 10px;
  border-radius: 11px;
  font-size: 12px;
  color: #1670c0;
  background: #ddf0fd;
}

.is-pc .step-body strong {
  display: block;
  font-size: 14px;
  color: #163b5c;
}

.is-pc .step-body p {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.7;
  color: #5b7488;
}

.is-pc .step-body b {
  color: #168de0;
}

.is-pc .qr-wrap {
  margin-top: 20px;
  text-align: center;
}

.is-pc .qr-image {
  display: inline-block;
  width: 200px;
  height: 200px;
  border: 1px solid #eef4f9;
  border-radius: 12px;
  background: #fafdff;
}

.is-pc .qr-tip {
  margin: 10px 0 0;
  font-size: 12px;
  color: #5b7488;
}

.is-pc .guide-entry {
  margin-top: 20px;
  padding: 13px 14px;
  border-radius: 10px;
  background: #ecfaf4;
}

.is-pc .guide-entry strong {
  display: block;
  font-size: 13px;
  color: #2b8967;
}

.is-pc .guide-entry p {
  margin: 5px 0 0;
  font-size: 12px;
  line-height: 1.7;
  color: #4a7a66;
}

.is-pc .entry-btn {
  width: 100%;
  height: 44px;
  margin-top: 22px;
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(100deg, #19a2e5, #146bd2);
  box-shadow: 0 6px 15px rgba(17, 112, 199, 0.22);
  cursor: pointer;
}

.is-pc .entry-btn:hover {
  opacity: 0.92;
}
</style>
